import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SetSubscriptionPaymentMethodMutation = graphql.persisted(
  "SetSubscriptionPaymentMethod",
  graphql(`
    mutation SetSubscriptionPaymentMethod($familyEnrollmentId: ID!, $paymentMethodId: ID) {
      setSubscriptionPaymentMethod(input: { familyEnrollmentId: $familyEnrollmentId, paymentMethodId: $paymentMethodId }) {
        userErrors { message path }
      }
    }
  `)
);

export { SetSubscriptionPaymentMethodMutation };

export function useSetSubscriptionPaymentMethod() {
  return useMutation(SetSubscriptionPaymentMethodMutation);
}
